export default "__VITE_ASSET__BfAeLP8M__"